import { useQuery } from '@tanstack/react-query';
import { getLanguages } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';

export const useLanguagesQuery = (opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'languages' ],
    queryFn: async () => {
      const spokenLanguages = await getLanguages();

      return spokenLanguages.data;
    },
    ...opts,
  });
};
